export default "__VITE_ASSET__BIgyJv0z__"